import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyPersonSearchBoxComponent } from '@nk/company-person-search-block';
import { SignUpService } from '@nk/core/services/sign-up.service';
import { SimpleSearchEntity, SimpleSearchWithDistanceEntity } from '@nk/data-entities-lib';
import { ButtonDirective } from '@nk/ui-lib';

@Component({
  selector: 'nk-sign-up-company',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, ButtonDirective, CompanyPersonSearchBoxComponent],
  templateUrl: './sign-up-company.component.html',
  styleUrls: ['./sign-up-company.component.scss'],
})
export class SignUpCompanyComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public showErrors = false;

  public industryTypeKeyList: string[];
  public searchItem: SimpleSearchWithDistanceEntity;
  public companyErrors = false;
  private _destroy = inject(DestroyRef);

  constructor(private _signUpService: SignUpService) {}

  public ngOnInit(): void {
    this.formGroup = this._signUpService.formCustomer;
    this.industryTypeKeyList = this._signUpService.industryTypeKeyList;
    this._signUpService
      .getShowError()
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe((showError) => {
        this.showErrors = showError;
      });
    this.formGroup.statusChanges.pipe(takeUntilDestroyed(this._destroy)).subscribe((statusChanges) => {
      if (this.formGroup.controls['company_uuid'].errors) {
        this.companyErrors = true;
      } else {
        this.companyErrors = false;
      }
    });
  }

  public onSimpleSearchSelect(simpleSearchEntity: SimpleSearchEntity): void {
    this.searchItem = simpleSearchEntity as SimpleSearchWithDistanceEntity;
    this.formGroup.controls.company_uuid.setValue(simpleSearchEntity.company_uuid);
    this.formGroup.controls.company_name.setValue(simpleSearchEntity.search_label);
  }

  public removeCompany(): void {
    this.searchItem = null;
    this.formGroup.controls.company_uuid.setValue(null);
    this.formGroup.controls.company_name.setValue(null);
  }
}
